// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 767.98px) {
	.overlapping-column-row {
		overflow-x: hidden;
		position: relative;
	}

	.project-selected {
	}
	
	#taskListColumn {
		/* display: none; */
		left: 0;
		position: absolute;
		/* right: -100%; */
		top: 0;
		transform: translate(100%, 0);
		transition: all .5s;
	}

	#taskListColumn.project-selected {
		/* display: block; */
		/* right: 0; */
		transform: translate(0, 0);
	}
}`, "",{"version":3,"sources":["webpack://./src/views/home/style.css"],"names":[],"mappings":"AAAA;CACC;EACC,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;CACA;;CAEA;EACC,mBAAmB;EACnB,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,6BAA6B;EAC7B,mBAAmB;CACpB;;CAEA;EACC,oBAAoB;EACpB,cAAc;EACd,0BAA0B;CAC3B;AACD","sourcesContent":["@media (max-width: 767.98px) {\r\n\t.overlapping-column-row {\r\n\t\toverflow-x: hidden;\r\n\t\tposition: relative;\r\n\t}\r\n\r\n\t.project-selected {\r\n\t}\r\n\t\r\n\t#taskListColumn {\r\n\t\t/* display: none; */\r\n\t\tleft: 0;\r\n\t\tposition: absolute;\r\n\t\t/* right: -100%; */\r\n\t\ttop: 0;\r\n\t\ttransform: translate(100%, 0);\r\n\t\ttransition: all .5s;\r\n\t}\r\n\r\n\t#taskListColumn.project-selected {\r\n\t\t/* display: block; */\r\n\t\t/* right: 0; */\r\n\t\ttransform: translate(0, 0);\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
